import { render } from "./PreviousAssessment.vue?vue&type=template&id=534f12bd&scoped=true"
import script from "./PreviousAssessment.vue?vue&type=script&lang=js"
export * from "./PreviousAssessment.vue?vue&type=script&lang=js"

import "./PreviousAssessment.vue?vue&type=style&index=0&id=534f12bd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534f12bd"]])

export default __exports__